import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Site footer, shared by every page.
 *
 * This was copy-pasted into Home and AboutUs. Adding a third copy for the
 * donate page would have meant keeping three sets of contact details and
 * links in step, so it is a component now.
 *
 * The id lives here because the navbar's Contact link scrolls to #footer.
 */
const Footer: React.FC = () => (
    <footer id="footer">
        <div className="footer-content">
            <div className="footer-section">
                <h4>Contact US</h4>
                <ul>
                    <li><a href="mailto:info@kilodeltaoncall.org">info@kilodeltaoncall.org</a></li>
                    <li><a href="tel:0832779727">John: 083 277 9727</a></li>
                    <li><a href="tel:0872655289">Support: 0872 655 289</a></li>
                    <li><a href="#facebook">Facebook</a></li>
                    <li><a href="#twitter">X.com (Twitter)</a></li>
                </ul>
            </div>
            <div className="footer-section">
                <h4>Get Involved</h4>
                <ul>
                    <li><Link to="/donate">Donate Now</Link></li>
                    <li><a href="mailto:info@kilodeltaoncall.org">Become a Volunteer</a></li>
                    <li><a href="mailto:info@kilodeltaoncall.org">Career Opportunities</a></li>
                    <li><a href="mailto:info@kilodeltaoncall.org">Partner With Us</a></li>
                </ul>
            </div>
        </div>
        <div className="footer-bottom">
            <p>&copy; 2025 Kilo Delta On Call (NPO). Registration Number 2025/750743/08. A registered non-profit organization dedicated to emergency response support. All rights reserved.</p>
            <p style={{ marginTop: '10px' }}>
                <Link to="/terms">Terms and Conditions</Link>
            </p>
        </div>
    </footer>
);

export default Footer;
